export default __webpack_public_path__ + "images/LO.b54aea4.png";